import './ScanSelfService.scss';

import cn from 'classnames';
import React, { useRef } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

import Picture from '@/common/components/atoms/Picture/Picture';
import { useConfig } from '@/common/contexts/ConfigContext';
import Overlay from '@/ebat/components/blocks/ScanSelfService/Overlay/Overlay';
import ProductModal from '@/ebat/components/blocks/ScanSelfService/ProductModal/ProductModal';
import SearchInput from '@/ebat/components/blocks/ScanSelfService/SearchInput/SearchInput';
import useLayoutDimensions from '@/ebat/components/pages/ScanSelfService/useLayoutDimensions';
import { useScanSelfServiceContext } from '@/ebat/contexts/ScanSelfServiceContext/ScanSelfServiceContext';

import ScanSelServiceImage from '../../../assets/images/scan-self-service/scan-self-service.svg';

const ScanSelfService = () => {
  const ref = useRef();
  const { t } = useTranslation();
  const { env } = useConfig();
  const { product, clearProduct } = useScanSelfServiceContext();
  const searchInputRef = useRef();
  const { panelMaxHeight } = useLayoutDimensions(searchInputRef);

  return (
    <>
      <Helmet>
        <title>
          {`${t('ebat:entities:scan_self_service.title')} - ${t(
            `${env}:messages:title`,
          )}`}
        </title>
      </Helmet>
      <main
        role="presentation"
        ref={ref}
        className="main scan-self-service-page"
        data-qa-id="scan-self-service-page"
      >
        <div className="wrapper wrapper--full scan-self-service-page__wrapper">
          <h2 className="scan-self-service-page__title" data-qa-id="title">
            {t('ebat:entities:scan_self_service.page-title')}
          </h2>
          <h2
            className="scan-self-service-page__search-title"
            data-qa-id="title"
          >
            {t('ebat:entities:scan_self_service.page-search')}
          </h2>
          <SearchInput
            className={cn('scan-self-service-page__search-input', {
              'scan-self-service-page__search-input--small-screen': false,
            })}
            ref={searchInputRef}
            panelMaxHeight={panelMaxHeight}
          />
          <ProductModal
            className="scan-self-service-page__product-modal"
            onClose={clearProduct}
            isOpen={!!product}
            /* eslint-disable-next-line react/jsx-props-no-spreading */
            {...(product ?? {})}
          />
          <div className="scan-self-service-page__blur">
            <Picture
              className="scan-self-service-page__picture"
              context="scan-self-service-page-picture"
              alt={t('ebat:entities:scan_self_service.page-title')}
              type="static"
              src={ScanSelServiceImage}
            />
          </div>
          <Overlay className="scan-self-service-page__overlay" />
        </div>
      </main>
    </>
  );
};

export default ScanSelfService;
